import React from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  image?: string;
  type?: string;
  noindex?: boolean;
  lang?: string;
  alternateLocales?: { hreflang: string; href: string }[];
}

const SEOHead = ({
  title = "Compresor de Imágenes Online Gratis - JPG, PNG, WebP | CompresorJPEG",
  description = "Comprime y optimiza imágenes JPG, PNG, WebP, GIF online gratis. Reduce el tamaño hasta 90% sin perder calidad. Herramienta rápida y segura para comprimir fotos.",
  keywords = "comprimir imagenes, compresion jpg, comprimir png, optimizar webp, reducir tamaño imagen, compresor fotos, comprimir imagenes online, optimizar fotografias",
  canonical = typeof window !== 'undefined'
    ? `https://compresorjpeg.com${window.location.pathname}`
    : undefined,
  image = "https://compresorjpeg.com/og-image.jpg",
  type = "website",
  noindex = false,
  lang = "es",
  alternateLocales
}: SEOHeadProps) => {
  
  React.useEffect(() => {
    // Update document title
    document.title = title;
    document.documentElement.lang = lang;

    // Update or create meta tags
    const updateMeta = (name: string, content: string, isProperty = false) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      
      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Update meta tags
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    updateMeta('robots', noindex ? 'noindex, follow' : 'index, follow');
    
    // Open Graph
    updateMeta('og:title', title, true);
    updateMeta('og:description', description, true);
    updateMeta('og:url', canonical, true);
    updateMeta('og:image', image, true);
    updateMeta('og:type', type, true);
    
    // Twitter
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
    updateMeta('twitter:image', image);
    
    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonical);

    // Update hreflang alternate links (only touch them when this route declares its own set,
    // otherwise leave the static defaults from index.html in place)
    if (alternateLocales) {
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
      alternateLocales.forEach(({ hreflang, href }) => {
        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', hreflang);
        link.setAttribute('href', href);
        document.head.appendChild(link);
      });
    }

  }, [title, description, keywords, canonical, image, type, noindex, lang, alternateLocales]);

  return null; // This component doesn't render anything
};

export default SEOHead;